module.exports = __webpack_public_path__ + "static/media/icon_action_tel_gray.ee3e0f50.svg";